import { render, staticRenderFns } from "./officeApproval.vue?vue&type=template&id=62b29e32&scoped=true"
import script from "./officeApproval.vue?vue&type=script&lang=js"
export * from "./officeApproval.vue?vue&type=script&lang=js"
import style0 from "./officeApproval.vue?vue&type=style&index=0&id=62b29e32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62b29e32",
  null
  
)

export default component.exports